export default __webpack_public_path__ + "static/media/Rubik-Black.11893ddb.ttf";